<template>
	<i class="fa" :class="sortClass"></i>
</template>
<script>
export default {
	props: {
		sortBy: String,
		column: String,
		sortDirection: String,
	},
	computed:{
		sortClass(){
			if(this.sortBy==this.column){
				return this.sortDirection == 'asc'?'fa-arrow-up':'fa-arrow-down';
			}
			return '';
		},
	},
};
</script>
